import { render } from "./Layout.vue?vue&type=template&id=6352d9da&scoped=true&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./layout.scss?vue&type=style&index=0&id=6352d9da&lang=scss&scoped=true"
import "./layout-global.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6352d9da"]])

export default __exports__